module.exports = __webpack_public_path__ + "static/media/family-1.e7260a77.png";